export default {
  appleAppStoreImageSrc: 'https://s3.amazonaws.com/static.jumpcloud.com/userportal/app-store.svg',
  appleAppStoreUrl: 'https://apps.apple.com/us/app/jumpcloud-protect/id1566884733',
  androidPlayStoreImageSrc: 'https://s3.amazonaws.com/static.jumpcloud.com/userportal/play-store.svg',
  androidPlayStoreUrl: 'https://play.google.com/store/apps/details?id=com.jumpcloud.JumpCloud_Protect',
  qualifiedAppsUrl: 'https://support.jumpcloud.com/support/s/article/TOTP-MFA-Overview-for-Users#JumpCloudTOTPMFA',
  verifyFailureMessage: 'Verification code was invalid or already used.',
};
